import { DateService } from '@shared/lib/services';

interface IOptions {
  extraDays: number;
  isYearValidation: boolean;
}

export const isValidDate = (
  dateString?: string,
  options = {
    extraDays: 0,
    isYearValidation: false,
  } as Partial<IOptions>
) => {
  if (!dateString) {
    return true;
  }

  const date = DateService.tryConvertToDate(dateString!, {
    extraDays: options.extraDays ?? 0,
  });

  if (!date) {
    return false;
  }

  return options?.isYearValidation ? DateService.isOldEnough(date) : DateService.validateDate(date);
};
